import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheck, Lock } from 'lucide-react';
export function CTASection() {
  const handleBuy = () => {
    if (typeof (window as any).fbq === 'function') {
      ;
      (window as any).fbq('track', 'AddToCart', {
        content_name: 'Plan B Migratorio',
        content_type: 'product',
        value: 6.99,
        currency: 'USD'
      });
    }
    window.location.href = 'https://simplementemejor.com/cart/51755419697432:1';
  };
  return <section id="cta-section" className="py-12 md:py-20 px-4 md:px-6 bg-[var(--bg-deep)] relative overflow-hidden" data-id="element-107">
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[800px] rounded-full pointer-events-none" style={{
      background: 'radial-gradient(circle, rgba(212,136,58,0.08) 0%, transparent 70%)'
    }} data-id="element-108" />

      <div className="max-w-[600px] mx-auto relative z-10" data-id="element-109">
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} className="bg-[var(--bg-card)] border border-[var(--accent)]/30 p-6 md:p-10 rounded-2xl text-center shadow-[0_8px_40px_rgba(0,0,0,0.2)]" data-id="element-110">
          {/* Guarantee Seal */}
          <div className="mx-auto w-16 h-16 bg-[var(--accent)]/10 rounded-full flex items-center justify-center mb-6 border border-[var(--accent)]/20" data-id="element-111">
            <ShieldCheck className="w-8 h-8 text-[var(--accent)]" data-id="element-112" />
          </div>

          <h2 className="text-2xl md:text-3xl font-serif text-[var(--text-heading)] mb-6" data-id="element-113">
            GARANTÍA DE HIERRO
          </h2>

          <div className="bg-[var(--bg-surface)] rounded-xl p-5 md:p-6 mb-8 text-left border border-[var(--border-subtle)]" data-id="element-114">
            <p className="text-sm md:text-base text-[var(--text-primary)] leading-relaxed" data-id="element-115">
              <strong className="text-[var(--accent)] block mb-2" data-id="element-116">
                MI GARANTÍA "CERO RIESGO":
              </strong>
              Tienes 7 días completos para revisar toda la información. Si
              sientes que esta hoja de ruta no vale 100 veces lo que pagaste, te
              devuelvo tus $6.97 de inmediato. Sin preguntas.
            </p>
          </div>

          {/* CTA Button */}
          <motion.button onClick={handleBuy} whileHover={{
          scale: 1.02
        }} whileTap={{
          scale: 0.98
        }} animate={{
          boxShadow: ['0 0 0 0 rgba(212,136,58,0)', '0 0 40px 12px rgba(212,136,58,0.4)', '0 0 0 0 rgba(212,136,58,0)']
        }} transition={{
          boxShadow: {
            duration: 2,
            repeat: Infinity,
            ease: 'easeInOut'
          }
        }} className="w-full py-4 md:py-5 bg-gradient-to-r from-[var(--accent)] to-[#e8a04c] text-[#110608] font-extrabold text-base md:text-lg rounded-xl shadow-lg flex items-center justify-center gap-2 mb-4" data-id="element-117">
            <Lock className="w-5 h-5 flex-shrink-0" data-id="element-118" />
            <span className="text-[14px]" data-id="element-119">
              SÍ, QUIERO MI GUÍA DE SALIDA POR $6.99
            </span>
          </motion.button>

          <div className="flex items-center justify-center gap-4 text-xs text-[var(--text-muted)]" data-id="element-120">
            <span className="flex items-center gap-1" data-id="element-121">
              <Lock className="w-3.5 h-3.5" data-id="element-122" /> Pago Seguro
            </span>
            <span className="opacity-30" data-id="element-123">|</span>
            <span className="flex items-center gap-1" data-id="element-124">
              <ShieldCheck className="w-3.5 h-3.5" data-id="element-125" /> 7 Días de Garantía
            </span>
          </div>
        </motion.div>
      </div>
    </section>;
}